import React, { useEffect, useState, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import HeadingCard from "../../../common/element/Card/HeadingCard";
import Sidebar from "./Sidebar";
import StepComponent from "./StepComponent";
import ResultPage from "./result";
import { fetchNcodes } from "../../../redux/tool/toolSlice";
import Footer from "../Footer";
import Button from "../../../common/element/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { getTestConfig } from "./testConfig";
import SweetAlertService from "../../../common/SweetAlert/SweetAlert";
// ✅ Import Expired Page
import ExpiredTokenPage from "../ExpiredTokenPage";
// ✅ Import checkTokenExpiry
import { checkTokenExpiry } from "../../../redux/tool/toolSlice";
import ThreeDotBouncingLoader from "../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import InvalidTokenPage from "../InvalidToken";
// ✅ Import LoginFormFORprospect
import LoginFormFORprospect from "../LoginFormFORprospect";
import { submitSessionUrl } from "../../../redux/SessionUrl/sessionUrlSlice";
import { selectSubmitSessionUrlData } from "../../../redux/SessionUrl/sessionUrlSelectors";

const StartScreen = ({ onStart, config }) => {
  const totalQuestions = config.totalSteps * config.questionsPerStep;
  const isTraitsTest = config.apiEndpoint === "traitstest";

  return (
    <div className="flex-1 p-6 bg-white">
      <HeadingCard title="Important Instructions">
        <ul className="space-y-4 ">
          {isTraitsTest ? (
            <>
              <li className="flex items-start md:items-center lg:items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 bg-[#FF8E1C] rounded-full font-lato not-italic font-semibold text-[14px] leading-[17px] text-white flex items-center justify-center mt-1">
                  1
                </span>
                <p className="font-lato not-italic font-bold text-[16px] md:text-[20px] lg:text-[20px] mobile_fix  text-start lg:text-center  leading-[115%] text-black">
                  In this assessment, you will see {totalQuestions} statements.
                </p>
              </li>

              <li className="flex items-start md:items-center lg:items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 bg-[#FF8E1C] rounded-full font-lato not-italic font-semibold text-[14px] leading-[17px] text-white flex items-center justify-center mt-1">
                  2
                </span>
                <p className="font-lato not-italic font-bold text-[16px] md:text-[20px] lg:text-[20px] mobile_fix  text-start lg:text-center leading-[115%] text-black">
                  For each statement you will see 5 options viz.
                </p>
              </li>

              <li className="flex items-start md:items-center lg:items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 bg-[#FF8E1C] rounded-full font-lato not-italic font-semibold text-[14px] leading-[17px] text-white flex items-center justify-center mt-1">
                  3
                </span>
                <div className="font-lato not-italic font-bold text-[16px] md:text-[20px] lg:text-[20px] mobile_fix  text-start lg:text-center leading-[115%] text-black">
                  a) Highly Inaccurate, b) Moderately Inaccurate, c) Neither
                  Accurate Nor Inaccurate, d) Moderately Accurate, e) Highly
                  Accurate
                </div>
              </li>

              <li className="flex items-start md:items-center lg:items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 bg-[#FF8E1C] rounded-full font-lato not-italic font-semibold text-[14px] leading-[17px] text-white flex items-center justify-center mt-1">
                  4
                </span>
                <p className="font-lato not-italic font-bold text-[16px] md:text-[20px] lg:text-[20px] mobile_fix  text-start lg:text-center leading-[115%] text-black">
                  For each statement you have to choose 1 option to which you
                  relate the most.
                </p>
              </li>

              <li className="flex items-start md:items-center lg:items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 bg-[#FF8E1C] rounded-full font-lato not-italic font-semibold text-[14px] leading-[17px] text-white flex items-center justify-center mt-1">
                  5
                </span>
                <p className="font-lato not-italic font-bold text-[16px] md:text-[20px] lg:text-[20px] mobile_fix  text-start lg:text-center leading-[115%] text-black">
                  Your answers should depict the real you.
                </p>
              </li>
            </>
          ) : (
            <>
              <li className="flex items-start md:items-center lg:items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 bg-[#FF8E1C] rounded-full font-lato not-italic font-semibold text-[14px] leading-[17px] text-white flex items-center justify-center mt-1">
                  1
                </span>
                <p className="font-lato not-italic font-bold text-[16px] md:text-[20px] lg:text-[20px] mobile_fix  text-start lg:text-center leading-[115%] text-black">
                  In this assessment, you will see {totalQuestions} questions.
                </p>
              </li>

              <li className="flex items-start md:items-center lg:items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 bg-[#FF8E1C] rounded-full font-lato not-italic font-semibold text-[14px] leading-[17px] text-white flex items-center justify-center mt-1">
                  2
                </span>
                <p className="font-lato not-italic font-bold text-[16px] md:text-[20px] lg:text-[20px] mobile_fix  text-start lg:text-center leading-[115%] text-black">
                  For each question, there are 3 possible answers viz. YES,
                  PARTLY, NO.
                </p>
              </li>

              <li className="flex items-start md:items-center lg:items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 bg-[#FF8E1C] rounded-full font-lato not-italic font-semibold text-[14px] leading-[17px] text-white flex items-center justify-center mt-1">
                  3
                </span>
                <div className="">
                  <p className="font-lato not-italic font-bold text-[16px] md:text-[20px] lg:text-[20px] mobile_fix  text-start lg:text-center leading-[115%] text-black">
                    Honestly consider each statement and select:
                  </p>
                </div>
              </li>
              <ul
                className="ml-[42px] space-y-1 mt-0 text-start"
                style={{ marginTop: 0 }}
              >
                <li className="font-lato not-italic font-bold text-[14px] md:text-[18px] lg:text-[18px] leading-[150%] text-[#555555]">
                  • <strong>YES</strong> – If you connect with the statement &
                  it feels like "this is really me"
                </li>
                <li className="font-lato not-italic font-bold text-[14px] md:text-[18px] lg:text-[18px] leading-[150%] text-[#555555]">
                  • <strong>PARTLY</strong> – If you partly connect with the
                  statement & it feels like "this is partly how I am"
                </li>
                <li className="font-lato not-italic font-bold text-[14px] md:text-[18px] lg:text-[18px] leading-[150%] text-[#555555]">
                  • <strong>NO</strong> – If you don't connect with the
                  statement & it feels like "this is probably not how I am"
                </li>
              </ul>
            </>
          )}
        </ul>
      </HeadingCard>

      <div className="text-center py-5">
        <Button
          onClick={onStart}
          className="mt-[32px]  w-[168px] h-[48px] rounded-[12px] text-white font-lato font-semibold text-[16px] leading-[115%] bg-[#FF8E1C] border border-[#FFF4E5]/50 shadow-[0px_2px_5px_#FFF4E5]"
        >
          START THIS TEST
        </Button>
      </div>
    </div>
  );
};

const InnerNeeds = () => {
  const location = useLocation();
  const testType = location.pathname.includes("traits-test")
    ? "traits-test"
    : "inner-needs";
  const config = getTestConfig(testType);

  // Clear prospect token from localStorage on mount (handles refresh)
  useEffect(() => {
    try {
      localStorage.removeItem('prospect_token');
    } catch (e) { }
  }, []);

  // ✅ Ref for scrolling to top
  const resultRef = useRef(null);

  // ✅ Extract token from URL query parameters
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const token = searchParams.get("token");

  // ✅ Extract prospect company params from URL
  const companyIdParam = searchParams.get("company_id");
  const companyNameParam = searchParams.get("company_name");
  const companySessionIdParam = searchParams.get("company_session_id");
  const sessionNameParam = searchParams.get("session_name");
  const sessionTypeParam = searchParams.get("session_type");
  const isSessionUrlFlow = sessionTypeParam === "session_url";

  // ✅ Whether prospect login should be shown before main flow
  const [prospectRequired] = useState(
    Boolean(companyIdParam && companyNameParam),
  );
  const [prospectConfirmed, setProspectConfirmed] = useState(false);
  const storedProspectToken = (() => { try { return localStorage.getItem('prospect_token'); } catch (e) { return null; } })();
  const [prospectToken, setProspectToken] = useState(storedProspectToken || token || null);
  // Stores name/email/phone collected during session_url check step
  const [sessionUrlUserData, setSessionUrlUserData] = useState(null);

  const [hasStarted, setHasStarted] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const questionsData = useSelector((state) => state.tool.ncodes.data);
  const quizResult = useSelector((state) => state.tool.innerNeedsSubmit?.data);
  const traitTestSubmit = useSelector(
    (state) => state.tool.traitTestSubmit?.data,
  );
  const submitSessionUrlData = useSelector(selectSubmitSessionUrlData);

  // ✅ Token Expiry Selectors
  const tokenExpiryData = useSelector(
    (state) => state.tool.tokenExpiryCheck.data,
  );
  const tokenExpiryLoading = useSelector(
    (state) => state.tool.tokenExpiryCheck.loading,
  );

  const [selections, setSelections] = useState(() => {
    const obj = {};
    for (let i = 1; i <= config.totalSteps; i++) obj[i] = {};
    return obj;
  });
  const [completed, setCompleted] = useState([]);
  const dispatch = useDispatch();

  // ✅ 1. Check Token Expiry on Mount
  useEffect(() => {
    if (token) {
      dispatch(checkTokenExpiry(token));
    }
  }, [dispatch, token]);

  // ✅ 2. Fetch Questions (only if not prospect required or already confirmed)
  useEffect(() => {
    if (!prospectRequired || prospectConfirmed) {
      dispatch(fetchNcodes(config.apiEndpoint));
    }
  }, [dispatch, config.apiEndpoint, prospectRequired, prospectConfirmed]);

  // ✅ Scroll to top when showing results
  useEffect(() => {
    if (showResults) {
      // Scroll to top of page
      window.scrollTo({ top: 0, behavior: "smooth" });

      // Also scroll the result ref into view if it exists
      if (resultRef.current) {
        resultRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, [showResults]);

  const currentStepQuestions = React.useMemo(() => {
    if (!questionsData || !Array.isArray(questionsData)) return [];
    const startIndex = (currentStep - 1) * config.questionsPerStep;
    const endIndex = startIndex + config.questionsPerStep;
    return questionsData.slice(startIndex, endIndex);
  }, [questionsData, currentStep, config.questionsPerStep]);

  const handleChange = (step) => (nextQuestionMap) => {
    setSelections((s) => ({ ...s, [step]: nextQuestionMap }));
  };

  const attemptedCount = Object.values(selections).reduce((sum, stepMap) => {
    return sum + Object.values(stepMap || {}).filter((v) => v).length;
  }, 0);

  const totalQuestions = config.totalSteps * config.questionsPerStep;

  const handleNext = async () => {
    if (!completed.includes(currentStep)) {
      setCompleted((c) => [...c, currentStep]);
    }

    if (currentStep === config.totalSteps) {
      let payload;

      if (config.apiEndpoint === "traitstest") {
        const response = [];

        if (questionsData && Array.isArray(questionsData)) {
          questionsData.forEach((question) => {
            for (let step = 1; step <= config.totalSteps; step++) {
              const stepSelections = selections[step] || {};

              if (stepSelections[question.id]) {
                const answerId = stepSelections[question.id];

                response.push({
                  questionId: question.id,
                  answer: answerId,
                });
                break;
              }
            }
          });
        }

        payload = {
          responses: response,
        };
      } else {
        const response = [];

        if (questionsData && Array.isArray(questionsData)) {
          questionsData.forEach((question) => {
            for (let step = 1; step <= config.totalSteps; step++) {
              const stepSelections = selections[step] || {};

              if (stepSelections[question.id]) {
                const answer = stepSelections[question.id];

                response.push({
                  questionId: question.id,
                  answer: answer.charAt(0).toUpperCase() + answer.slice(1),
                });
                break;
              }
            }
          });
        }
        payload = {
          userAnswers: response,
        };
      }

      // ✅ Set loading state
      setIsSubmitting(true);

      try {
        let resultAction;

        if (isSessionUrlFlow) {
          // session_url flow: submit to public endpoint with user data + result_json
          resultAction = await dispatch(
            submitSessionUrl({
              company_session_id: Number(companySessionIdParam),
              name: sessionUrlUserData?.name || "",
              email: sessionUrlUserData?.email || "",
              phone: sessionUrlUserData?.phone || "",
              result_json: payload,
            })
          );

          if (submitSessionUrl.rejected.match(resultAction)) {
            const errorMessage =
              resultAction.payload || "Something went wrong. Please try again.";
            SweetAlertService.showError({
              title: "Error!",
              message: errorMessage,
              onConfirm: () => { setIsSubmitting(false); },
            });
            setIsSubmitting(false);
            return;
          }

          if (submitSessionUrl.fulfilled.match(resultAction)) {
            SweetAlertService.showSuccess({
              title: "Success!",
              message: "Test has been submitted successfully.",
              onConfirm: () => {
                setIsSubmitting(false);
                setShowResults(true);
                window.scrollTo({ top: 0, behavior: "smooth" });
              },
            });
          }
        } else {
          // ✅ Use prospectToken if available, otherwise use the route token
          const effectiveToken = prospectToken || token || null;
          // ✅ Updated: Pass both payload and token to the submit action
          resultAction = await dispatch(
            config.submitAction({ payload, token: effectiveToken }),
          );

          // ✅ Check if the action was rejected - Show Error Alert
          if (config.submitAction.rejected.match(resultAction)) {
            const errorMessage =
              resultAction.payload || "Something went wrong. Please try again.";

            SweetAlertService.showError({
              title: "Error!",
              message: errorMessage,
              onConfirm: () => {
                setIsSubmitting(false);
              },
            });

            setIsSubmitting(false);
            return; // ✅ Don't navigate to results page on error
          }

          // ✅ Check if the action was fulfilled - Show Success Alert and navigate to results
          if (config.submitAction.fulfilled.match(resultAction)) {
            SweetAlertService.showSuccess({
              title: "Success!",
              message: "Test has been submitted successfully.",
              onConfirm: () => {
                setIsSubmitting(false);
                setShowResults(true); // ✅ Navigate to results page after confirmation
                // ✅ Scroll to top to show results
                window.scrollTo({ top: 0, behavior: "smooth" });
              },
            });
          }
        }
      } catch (error) {
        // ✅ Handle any unexpected errors
        console.error("API Error:", error);
        const errorMessage =
          error?.message || "An unexpected error occurred. Please try again.";

        SweetAlertService.showError({
          title: "Error!",
          message: errorMessage,
          onConfirm: () => {
            setIsSubmitting(false);
          },
        });

        setIsSubmitting(false);
      }
    } else {
      setCurrentStep((s) => s + 1);
    }
  };

  const handlePrev = () => {
    if (currentStep > 1) {
      setCompleted((c) => c.filter((step) => step !== currentStep));
      setCurrentStep((s) => s - 1);
    }
  };

  const handleSelectStep = (step) => {
    if (hasStarted && !showResults) {
      setCurrentStep(step);
    }
  };

  const handleStart = () => {
    setHasStarted(true);
    setCurrentStep(1);
  };

  // ✅ Modified Handle Restart (Go Home)
  const handleRestart = () => {
    // 1. Reset all state
    setHasStarted(false);
    setShowResults(false);
    setCurrentStep(0);
    setSelections(() => {
      const obj = {};
      for (let i = 1; i <= config.totalSteps; i++) obj[i] = {};
      return obj;
    });
    setCompleted([]);

    // 2. For session_url flow, go back to login form
    if (isSessionUrlFlow) {
      setProspectConfirmed(false);
      setSessionUrlUserData(null);
      return;
    }

    // 3. Re-check token expiry
    if (token) {
      dispatch(checkTokenExpiry(token));
    }
  };

  const isStepComplete =
    Object.values(selections[currentStep] || {}).filter((v) => v).length ===
    config.questionsPerStep;

  // ============================================
  // CONDITIONAL RENDER LOGIC
  // ============================================

  // ✅ 3. Prospect Login View (before token checks)
  if (prospectRequired && !prospectConfirmed) {
    // ✅ Determine headerOverrides based on test type
    const headerOverrides =
      testType === "traits-test"
        ? {
          title: "Identify Your 7 Character Traits Assessment",
          subtitle: "Enter your details to access the tool",
          highlighted: "",
        }
        : {
          // title: "INNER NEEDS ASSESSMENT\nDiscover Your Top 2 Inner Needs",
          title: (
            <>
              INNER NEEDS ASSESSMENT <br />
              Discover Your Top 2 Inner Needs
            </>
          ),
          subtitle: "Enter your details to access the tool",
          highlighted: "",
        };

    const initialValues = {
      company_id: Number(companyIdParam) || 0,
      company_name: companyNameParam || "",
    };

    return (
      <LoginFormFORprospect
        headerOverrides={headerOverrides}
        initialValues={initialValues}
        sessionType={sessionTypeParam}
        sessionName={sessionNameParam}
        companySessionId={companySessionIdParam}
        onSuccess={(payload) => {
          if (isSessionUrlFlow && payload?.userData) {
            setSessionUrlUserData(payload.userData);
          }
          setProspectConfirmed(true);
          const returnedToken = payload?.token || payload?.data?.token || null;
          if (returnedToken) {
            setProspectToken(returnedToken);
            try { localStorage.setItem('prospect_token', returnedToken); } catch (e) { }
          }
          dispatch(fetchNcodes(config.apiEndpoint));
        }}
      />
    );
  }

  // ✅ 2. Loading State for Token Check
  if (tokenExpiryLoading) {
    return (
      <div className="w-full min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <ThreeDotBouncingLoader />
        </div>
      </div>
    );
  }
  // ✅ 2 If tokenExpiryData exists and is not empty, the token is invalid/used.
  if (
    tokenExpiryData?.token_valid == false &&
    tokenExpiryData?.expired == false
  ) {
    return <InvalidTokenPage />;
  }
  // ✅ 3. Expired Token Logic
  // If tokenExpiryData exists and is not empty, the token is invalid/used.
  if (tokenExpiryData?.expired == true) {
    return <ExpiredTokenPage />;
  }

  return (
    <div className="w-full min-h-screen bg-gray-50" ref={resultRef}>
      {/* Mobile Header - Shows below 993px */}
      <div className="mobile-responsive md-993:hidden">
        <div className="">
          <img
            src="./../assets/images/Logo-Incredible-Leaders.png"
            width={120}
            alt="Incredible Leaders"
          />
        </div>
        <div
          className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          role="button"
          aria-label="Toggle menu"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              setIsMobileMenuOpen(!isMobileMenuOpen);
            }
          }}
        >
          <svg
            width="24"
            height="19"
            viewBox="0 0 32 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.52381C0 0.682225 0.68224 0 1.52381 0H30.4762C31.3178 0 32 0.682225 32 1.52381C32 2.36539 31.3178 3.04762 30.4762 3.04762H1.52381C0.68224 3.04762 0 2.36539 0 1.52381Z"
              fill="black"
            />
            <path
              d="M0 12.1902C0 11.3486 0.68224 10.6662 1.52381 10.6662L18.2857 10.6667C19.1273 10.6667 19.8095 11.3489 19.8095 12.1905C19.8095 13.0321 19.1273 13.7143 18.2857 13.7143L1.52381 13.714C0.68224 13.714 0 13.0316 0 12.1902Z"
              fill="black"
            />
            <path
              d="M1.52381 21.333C0.68224 21.333 0 22.0152 0 22.8568C0 23.6983 0.68224 24.3805 1.52381 24.3805H27.4286C28.2702 24.3805 28.9524 23.6983 28.9524 22.8568C28.9524 22.0152 28.2702 21.333 27.4286 21.333H1.52381Z"
              fill="black"
            />
          </svg>
        </div>
      </div>

      {/* Main Content Area with Sidebar */}
      <div className="w-full flex gap-0">
        <Sidebar
          currentStep={showResults ? 0 : currentStep}
          onSelectStep={handleSelectStep}
          completedSteps={completed}
          totalSteps={config.totalSteps}
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />

        {!hasStarted ? (
          <StartScreen onStart={handleStart} config={config} />
        ) : showResults ? (
          <ResultPage
            selections={selections}
            onRestart={handleRestart} // ✅ Passed new restart handler
            quizResult={isSessionUrlFlow ? submitSessionUrlData : quizResult}
            traitTestSubmit={isSessionUrlFlow ? submitSessionUrlData : traitTestSubmit}
            config={config}
          />
        ) : (
          <div className="flex-1 p-2 md:p-6 lg:p-6">
            <HeadingCard
              title={
                <div className="flex justify-between items-center w-full">
                  <span className="font-lato not-italic font-bold text-[18px] md:text-[24px]  leading-[115%] text-white">
                    {config.title}
                  </span>
                  <span className="font-lato not-italic font-bold text-[16px] md:text-[24px] leading-[115%] text-white">
                    Attempted Questions: {attemptedCount}/{totalQuestions}
                  </span>
                </div>
              }
            >
              <StepComponent
                step={currentStep}
                questionsData={currentStepQuestions}
                selected={selections[currentStep]}
                onChange={handleChange(currentStep)}
                isFirstStep={currentStep === 1}
                isLastStep={currentStep === config.totalSteps}
                questionsPerStep={config.questionsPerStep}
                config={config}
              />
            </HeadingCard>

            <div className="flex justify-center items-center gap-4 pt-4 mt-4">
              <Button
                onClick={handlePrev}
                disabled={currentStep === 1 || isSubmitting}
                className={`bg-[#FFF4E5] text-black px-[18px] py-4 w-[150px] h-14 rounded-[12px] font-lato not-italic font-bold text-[16px] leading-[150%] ${currentStep === 1 || isSubmitting
                    ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                    : "bg-[#FFF4E5] border border-[#FFF4E5] text-black "
                  }`}
              >
                Previous
              </Button>

              <Button
                onClick={handleNext}
                disabled={!isStepComplete || isSubmitting}
                className={`px-[18px] py-4 w-[150px] h-14 rounded-[12px] font-lato not-italic font-bold text-[16px] leading-[150%] transition-all duration-200 ${isStepComplete && !isSubmitting
                    ? "bg-[#FF8E1C] text-white hover:bg-[#E67E0C]"
                    : "bg-gray-200 text-gray-400 cursor-not-allowed"
                  }`}
              >
                {isSubmitting ? (
                  <div className="flex items-center justify-center gap-2">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    <span>Submitting...</span>
                  </div>
                ) : currentStep === config.totalSteps ? (
                  "Submit"
                ) : (
                  "Next"
                )}
              </Button>
            </div>

            <div className="mt-6">
              <Footer />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InnerNeeds;
